module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.updatesVisible) ? _c('div', [_c('el-button', {
    staticClass: "btn btn--shadow btn--tertiary",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.showUpdates()
      }
    }
  }, [_vm._v(_vm._s(_vm.titleMain))])], 1) : _c('div', [_vm._l((_vm.getSiteUpdates.measures), function(measure) {
    return _c('switcher', {
      key: measure.id,
      attrs: {
        "question": measure
      },
      on: {
        "update": _vm.update
      }
    })
  }), _c('h1', {
    staticClass: "txt-center"
  }, [_vm._v(_vm._s(_vm.titleEstimation))]), _c('div', {
    staticClass: "row result__scores mb-30"
  }, [_c('div', {
    staticClass: "txt-center gr-12@xs mb-15@xs gr-6"
  }, [_c('h6', {
    staticClass: "result__scores__title"
  }, [_vm._v(_vm._s(_vm.titleCategory))]), _c('span', {
    staticClass: "result__score"
  }, [_vm._v(_vm._s(_vm.getSiteUpdates.siteSecurityClassification))])]), _c('div', {
    staticClass: "txt-center gr-12@xs gr-6"
  }, [_c('h6', {
    staticClass: "result__scores__title"
  }, [_vm._v(_vm._s(_vm.titleRiskLevel))]), _c('span', {
    staticClass: "result__score result__score--${result.riskLevel}"
  }, [_vm._v(_vm._s(_vm.getSiteUpdates.riskLevel))])])])], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68b42061","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/improvements.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-68b42061","preserveWhitespace":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./public/js/components/improvements.vue
// module chunks = 0